<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/professions-foreign-amounts`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h4>Сумма 1 месяца за {{dto.year}} год</h4>
      <h5>{{dto.profession.code}} {{dto.profession.nameRu}}</h5>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="sum" class="form-label col-md-2">
            Сумма 1 месяца
          </label>
          <div class="col-md-7">
            <input class="form-control" id="sum" type="number" min="0" step="0.01"
                   v-model="dto.sum">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-footer justify-content-end"  v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import professionForeignAmountsService from "@/services/professionForeignAmountsService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  computed: {
    professionUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      dto: {
        year: null,
        profession: {
          code: null,
          nameRu: null
        },
        sum: null
      }
    };
  },
  methods: {
    init() {
      this.findById(this.professionUuid);
    },
    async findById(uuid) {
      this.isLoading = true;
      this.dto = await professionForeignAmountsService.findByUuid(uuid);
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;
        this.dto = await professionForeignAmountsService.save(this.dto);
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
